import { render, staticRenderFns } from "./USC_21_020.vue?vue&type=template&id=dccf6d4e&scoped=true"
import script from "./USC_21_020.vue?vue&type=script&lang=js"
export * from "./USC_21_020.vue?vue&type=script&lang=js"
import style0 from "./USC_21_020.vue?vue&type=style&index=0&id=dccf6d4e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccf6d4e",
  null
  
)

export default component.exports